import { DriverErrorType, DriverError } from '@fluidframework/driver-definitions';

export function isDriverGenericError(error: DriverError) {
  return error.errorType === DriverErrorType.genericError;
}

export function isFileNotFoundOrAccessDeniedError(error: DriverError) {
  return error.errorType === DriverErrorType.fileNotFoundOrAccessDeniedError;
}

export function isAuthorizationError(error: DriverError) {
  return error.errorType === DriverErrorType.authorizationError;
}

export function isDriverThrottlingError(error: DriverError) {
  return error.errorType === DriverErrorType.throttlingError;
}

/**
 * Match a error against known fluid driver error types
 * @param error potential driver error
 * @returns DriverErrorType in case of a match
 */
export function tryMatchDriverErrorType(error: unknown): DriverErrorType | undefined {
  if (typeof error === 'object') {
    const typedError = error as DriverError;

    if (isDriverGenericError(typedError)) {
      return DriverErrorType.genericError;
    }

    if (isFileNotFoundOrAccessDeniedError(typedError)) {
      return DriverErrorType.fileNotFoundOrAccessDeniedError;
    }

    if (isAuthorizationError(typedError)) {
      return DriverErrorType.authorizationError;
    }

    if (isDriverThrottlingError(typedError)) {
      return DriverErrorType.throttlingError;
    }

    // ... try match any other known driver error types
  }

  return;
}
